import { createSlice } from '@reduxjs/toolkit';
import { addNewCourse, addNewVideo, editCourse, getActiveCourses, getAllCourses, getCourseById } from './coursesService';

const initialState = {
  allCourses: {
    isCoursesLoading: null,
    isCoursesSuccess: null,
    coursesMessage: null,
    pageCount: 0,
    courses: [],
  },
  course: {
    isCourseLoading: null,
    isCourseSuccess: null,
    courseMessage: null,
    course: null,
  },
  newCourse: {
    isCourseCreating: null,
    isCourseCreated: null,
    courseCreationMsg: null,
  },
  editedCourse: {
    isEditingCourse: null,
    isCourseEdited: null,
    courseEditedMsg: null
  },
  newVideo: {
    isVideoCreating: null,
    isVideoCreated: null,
    videoCreationMsg: null,
  }, 
   activeCourses: {
    isCoursesLoading: null,
    isCoursesSuccess: null,
    coursesMessage: null,
    pageCount: 0,
    courses: [],
  },
};

const coursesSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCourses.pending, (state) => {
        state.allCourses = {
          ...initialState.allCourses, // Reset to initial state
          isCoursesLoading: true,
          coursesMessage: 'Loading',
        };
      })
      .addCase(getAllCourses.rejected, (state, action) => {
        state.allCourses = {
          ...initialState.allCourses,
          isCoursesLoading: false,
          isCoursesSuccess: false,
          coursesMessage: action.payload || 'Error occurred while fetching courses',
        };
      })
      .addCase(getAllCourses.fulfilled, (state, action) => {
        state.allCourses = {
          ...initialState.allCourses,
          isCoursesLoading: false,
          isCoursesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          courses: action.payload.data || [],
        };
      });

    builder
      .addCase(getCourseById.pending, (state) => {
        state.course = {
          ...initialState.course, // Reset to initial state
          isCourseLoading: true,
          courseMessage: 'Loading',
        };
      })
      .addCase(getCourseById.rejected, (state, action) => {
        state.course = {
          ...initialState.course,
          isCourseLoading: false,
          isCourseSuccess: false,
          courseMessage: action.payload || 'Error occurred while fetching course',
        };
      })
      .addCase(getCourseById.fulfilled, (state, action) => {
        state.course = {
          ...initialState.course,
          isCourseLoading: false,
          isCourseSuccess: true,
          course: action.payload,
        };
      });

    //Course creating
    builder
      .addCase(addNewCourse.pending, (state) => {
        state.newCourse = {
          ...initialState.newCourse, // Reset to initial state
          isCourseCreating: true,
          courseCreationMsg: 'Loading',
        };
      })
      .addCase(addNewCourse.rejected, (state, action) => {
        state.newCourse = {
          ...initialState.newCourse,
          isCourseCreating: false,
          isCourseCreated: false,
          courseCreationMsg: action.payload || 'Error occurred while creating the course.',
        };
      })
      .addCase(addNewCourse.fulfilled, (state, action) => {
        state.newCourse = {
          ...initialState.newCourse,
          isCourseCreating: false,
          isCourseCreated: true,
          courseCreationMsg: action.payload || 'Successfully created the course.',
        };
      });

    //Course editing
    builder
      .addCase(editCourse.pending, (state) => {
        state.editedCourse = {
          ...initialState.editedCourse, // Reset to initial state
          isEditingCourse: true,
          courseEditedMsg: 'Loading',
        };
      })
      .addCase(editCourse.rejected, (state, action) => {
        state.editedCourse = {
          ...initialState.editedCourse, // Reset to initial state
          isEditingCourse: false,
          isCourseEdited: false,
          courseEditedMsg: action.payload || 'Error occurred while editing the course.',
        };
      })
      .addCase(editCourse.fulfilled, (state, action) => {
        state.editedCourse = {
          ...initialState.editedCourse, // Reset to initial state
          isEditingCourse: false,
          isCourseEdited: true,
          courseEditedMsg: action.payload || 'Successfully edited the course.',
        };
      });

    //Video creating
    builder
      .addCase(addNewVideo.pending, (state) => {
        state.newVideo = {
          ...initialState.newVideo,
          isVideoCreating: true,
          videoCreationMsg: 'Loading',
        };
      })
      .addCase(addNewVideo.rejected, (state, action) => {
        state.newVideo = {
          ...initialState.newVideo,
          isVideoCreating: false,
          isVideoCreated: false,
          videoCreationMsg: action.payload || 'Error occurred while creating the video.',
        };
      })
      .addCase(addNewVideo.fulfilled, (state, action) => {
        state.newVideo = {
          ...initialState.newVideo,
          isVideoCreating: false,
          isVideoCreated: true,
          videoCreationMsg: action.payload || 'Successfully created the video.',
        };
      });

      // Active courses
        builder
      .addCase(getActiveCourses.pending, (state) => {
        state.activeCourses = {
          ...initialState.activeCourses, // Reset to initial state
          isCoursesLoading: true,
          coursesMessage: 'Loading',
        };
      })
      .addCase(getActiveCourses.rejected, (state, action) => {
        state.activeCourses = {
          ...initialState.activeCourses,
          isCoursesLoading: false,
          isCoursesSuccess: false,
          coursesMessage: action.payload || 'Error occurred while fetching active courses',
        };
      })
      .addCase(getActiveCourses.fulfilled, (state, action) => {
        state.activeCourses = {
          ...initialState.activeCourses,
          isCoursesLoading: false,
          isCoursesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          courses: action.payload.data || [],
        };
      });
  },
});

export default coursesSlice.reducer;
